import useUser from "hooks/useUser"
import { useLocation } from "react-router"

/** @returns {string[]} */
export const useFiltersConfiguration = (
  configKey = null,
  defaultFilters = []
) => {
  const user = useUser()
  const defaultFiltersConfigurationKey = useDefaultFiltersConfigurationKey()

  const userConfiguration =
    user.settings.filter_configuration?.[
      configKey || defaultFiltersConfigurationKey
    ] ?? []

  return userConfiguration.length ? userConfiguration : defaultFilters
}

export const useDefaultFiltersConfigurationKey = () => {
  return useLocation().pathname
}
